<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.rent_recipt_logs && wrapper">
    <div class="banner center">
        <div class="row freeze_height">
            <div class="col-md-4">
                <ngx-select *ngIf="localService.countryCodes && (reqCountryId == '' || reqCountryId == '0')"
                    [(ngModel)]="selectedCountryCode" [optionValueField]="'v2'" [optionTextField]="'v1'"
                    [items]="localService.countryCodes" (select)="onLoad()" [noAutoComplete]="true">
                </ngx-select>
            </div>
            <div class="col-md-4">
                <ngx-select *ngIf="interactionTypes && (reqCountryId == '' || reqCountryId == '0')"
                    [(ngModel)]="selectedIntercationType" [optionValueField]="'key'" [optionTextField]="'value'"
                    [items]="interactionTypes" (select)="onLoad()" [noAutoComplete]="true">
                </ngx-select>
            </div>
        </div>
        <div class="row row_header freeze_col freeze_height">
            <div class="col-md-3">
                <span>{{localService.languageContent.rent_recipt_logs.time_stamp}}</span>
            </div>
            <div class="col-md-1">
                <span>{{localService.languageContent.rent_recipt_logs.total_recs}}</span>
            </div>
            <div class="col-md-1">
                <span>{{localService.languageContent.rent_recipt_logs.proc_recs}}</span>
            </div>
            <div class="col-md-2">
                <span>{{localService.languageContent.rent_recipt_logs.amount}}</span>
            </div>
            <div class="col-md-1">
                <span>{{localService.languageContent.rent_recipt_logs.paid_amount}}</span>
            </div>
            <div class="col-md-1">
                <span>{{localService.languageContent.rent_recipt_logs.waived_amount}}</span>
            </div>
            <div class="col-md-1">
                <span>{{localService.languageContent.rent_recipt_logs.free_amount}}</span>
            </div>
            <div class="col-md-2">
                <span>{{localService.languageContent.rent_recipt_logs.total_amount}}</span>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row" *ngFor="let item of wrapper.items">
                <div class="col-md-3">
                    <a class="button" *ngIf="reqTimeStamp == '0'"
                        [routerLink]="['/rentlogs', ctryCode, userId, interactionType, item.v6, selectedCountryId, reqStateId == '0' && item.v2 != '' ? item.v2 : reqStateId, reqStateId != '0' && reqDistrictId == '0' && item.v2 != '' ? item.v2 : reqDistrictId,reqStateId != '0' && reqDistrictId != '0' && reqConstituencyId == '0' && item.v2 != '' ? item.v2 : reqConstituencyId]"><i
                            class="material-icons button icon_adjust">account_tree</i></a>
                    <span *ngIf="reqTimeStamp == '0'" class="en">{{item.v6}}&nbsp;-&nbsp;{{item.v1 | localDate}}</span>
                    <span *ngIf="reqTimeStamp != '0'">{{item.v3}}</span>
                    <button class="button_icon button_icon_color" style="height: 35px;" *ngIf="item.v14 != ''"
                        (click)="onOpenInvoice(item.v14,1)">receipt</button>
                    <button class="button_icon button_icon_color" style="height: 35px;" *ngIf="item.v14 != ''"
                        (click)="onOpenInvoice(item.v14,2)">print</button>
                    <span *ngIf="item.v2 != '' && item.v14 == ''"
                        [ngClass]="localService.getLanguageCode(item.v6)">{{item.v3}}</span>
                    <span *ngIf="item.v2 != '' && item.v14 != ''" [ngClass]="localService.getLanguageCode(item.v6)"
                        (click)="localService.showSummaryWithCtry(item.v2, localService.onGetSummaryType(selectedIntercationType))"
                        class="button">{{item.v3}}</span>
                </div>
                <div class="col-md-1" style="text-align: right;">
                    <span class="en">{{item.v7}}</span>
                </div>
                <div class="col-md-1" style="text-align: right;">
                    <span class="en">{{item.v8}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="en">{{item.v9 | number: '1.2-2'}}</span>
                </div>
                <div class="col-md-1" style="text-align: right;">
                    <span class="en">{{item.v10 | number: '1.2-2'}}</span>
                </div>
                <div class="col-md-1" style="text-align: right;">
                    <span class="en">{{item.v11 | number: '1.2-2'}}</span>
                </div>
                <div class="col-md-1" style="text-align: right;">
                    <span class="en">{{item.v12 | number: '1.2-2'}}</span>
                </div>
                <div class="col-md-2" style="text-align: right;">
                    <span class="en">{{item.v13 | number: '1.2-2'}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-paging [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
<app-print *ngIf="IsPrint" [fileName]="fileName" [content]="printContent" (onPrinted)="onPrinted()">
</app-print>